import catchErrors from './catchErrors'
import { fixtureMacros } from '@/services/__fixtures__/macros'

const MOCK_ENABLED = import.meta.env.VITE_AGENT_GATEWAY_MOCK === 'true'

export default {
  dispatchCommand(stationId, type, payload) {
    return catchErrors.post(`/v2/stations/${stationId}/agent/commands`, { type, payload })
  },

  getMacros(platformId) {
    if (MOCK_ENABLED) return Promise.resolve({ data: fixtureMacros })
    return catchErrors.get(`/v2/platforms/${platformId}/macros`)
  },

  executeMacro(macroId) {
    if (MOCK_ENABLED) return Promise.resolve({ data: { success: true } })
    return catchErrors.post(`/v2/macros/${macroId}/execute`)
  }
}
